import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IUser from "Types/User";

export const GET_USERS = "[USER] GET_USERS";
export const GET_USERS_SUCCESS = "[USER] GET_USERS_SUCCESS";
export const GET_USERS_FAILED = "[USER] GET_USERS_FAILED";

export const SET_VALUE = "[USER EDIT] SET_VALUE";
export const CLEAR_VALUES = "[USER EDIT] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getUsers(
	skip?: number,
	take: number = 10,
	filter?: any[] | any,
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<IUser[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_USERS });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/User?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_USERS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_USERS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_USERS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
